
import { AuthKeys } from '@/i18n/types';

export const auth: Record<AuthKeys, string> = {
  email: 'Email',
  password: 'Password',
  name: 'Name',
  confirmPassword: 'Confirm Password',
  namePlaceholder: 'Enter your name',
  signIn: 'Sign In',
  signUp: 'Sign Up',
  signOut: 'Sign Out',
  forgotPassword: 'Forgot Password?',
  resetPassword: 'Reset Password',
  changePassword: 'Change Password',
  creatingAccount: 'Creating account...',
  authError: 'Authentication error. Please sign in again.',
  alreadyHaveAccount: 'Already have an account?',
  checkEmailConfirmation: 'Please check your email to confirm your account',
  createAccountDesc: 'Create an account to start managing your life',
  passwordMismatch: 'Passwords do not match',
  emailAlreadyRegistered: 'Email already registered',
  login: 'Login',
  loginButton: 'Log In',
  signupButton: 'Sign Up',
  invalidEmail: 'Invalid Email',
  requiredField: 'This field is required',
  enterNewPassword: 'Enter your new password',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  confirmYourNewPassword: 'Confirm your new password',
  updatePassword: 'Update password',
  enterEmailResetPassword: 'Enter your email to reset your password',
  enterEmail: 'Enter your email',
  enterPassword: 'Enter your password',
  confirmYourPassword: 'Confirm your password',
  backToLogin: 'Back to login',
  emailSent: 'Email sent',
  emailSentDescription: 'Check your inbox to reset your password',
  emailSentToAddress: 'We have sent a reset link to {email}',
  checkInboxDescription: 'Check your inbox and click the link to reset your password',
  checkSpamDescription: 'Don\'t see the email? Check your spam folder or try again',
  sendAgain: 'Send again',
  sending: 'Sending',
  sendResetLink: 'Send reset link',
  invalidEmailDescription: 'Please enter a valid email address',
  rateLimitError: 'Too many attempts',
  rateLimitDescription: 'You have made too many attempts. Please wait a moment before trying again',
  emailNotFoundDescription: 'No account found with this email address',
  resetEmailError: 'Could not send reset email',
  unexpectedError: 'An unexpected error occurred. Please try again',
};
